module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Bucket-f696ca5651a630964ab4dde43cfd06c63f869de73196f5435523ee4532175e1d.svg";